import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {validate} from 'validate.js';
import {
    Row, Col, Form,
    FormGroup, FormFeedback, Input,
    Button, FormText, Label
  } from 'reactstrap';

import { authActions } from '../../../actions';
import { getFullUser } from '../../../selectors';

import WaiverPDF from '../../../assets/Waiver.pdf';
import '../Auth.css';

validate.validators.checked = function(value, options) {
    if (value !== 'true') return options.message || "Must be checked";
};

const constraints = {
    firstName: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        },
    },
    lastName: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        },
    },
    email: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        },
        email: {
            message: "Doesn't look like a valid email"
        }
    },
    password: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        },
        length: {
            minimum: 6,
            message: "Must be at least 6 characters"
        }
    },
    confirmPassword: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        }
    },
    agreeTOS: {
        checked: {
            message: "Must read and accept waiver"
        }
    }
};


class Register extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            globalError: '',
            firstName: {
                value: '',
                validateCSS: '',
                errors: []
            },
            lastName: {
                value: '',
                validateCSS: '',
                errors: []
            },
            email: {
                value: '',
                validateCSS: '',
                errors: []
            },
            password: {
                value: '',
                validateCSS: '',
                errors: []
            },
            confirmPassword: {
                value: '',
                validateCSS: '',
                errors: []
            },
            agreeTOS: {
                value: false,
                validateCSS: '',
                errors: []
            }
        };
    }

    validateInput(input, inputName) {
        let err = validate.single(input, constraints[inputName]);
        const inputState = this.state[inputName];

        if(!inputState)
            return undefined;

        if(inputName === "confirmPassword"){
            if(!err){
                if(input !== this.state.password.value){
                    err = ['Passwords do not match'];
                }
            }
        }

        if(!err){
            inputState.errors = [];
            inputState.validateCSS = 'has-success'
        } else {
            inputState.errors = err;
            inputState.validateCSS = 'has-danger'
        }
        this.setState({ [inputName]: inputState });
        return err;
    }

    handleChange = (event) => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;

        const inputState = this.state[name];
        inputState.value = value;

        this.setState({ globalError: '' });
        this.setState({ [name]: inputState });
    }

    submitForm(e) {
        e.preventDefault();
        const { email, firstName, lastName, password } = this.state;
        const formElements = [...e.target.elements];
        const errors = formElements.map((fe) => {
                return this.validateInput(fe.value, fe.name);
            })
            .filter((fe) => {
                return fe;
            });

        if(errors.length === 0){
            this.props.register(firstName.value, lastName.value, email.value, password.value);
            return true;
        }
        return false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.user.error && (prevProps.user !== this.props.user)) {
            const errorDetails = this.props.user.error.details;
            let errorMessage = "";
            if(errorDetails){
                for(let i = 0; i < errorDetails.length; i++){
                    errorMessage += `${errorDetails[i].message}\n`;
                }
            }
            this.setState({ globalError: errorMessage });
        }
    }

    renderError(){
        if(this.state.globalError) {
            return <div className="auth-form-error">{this.state.globalError}</div>
        }
    }

    render() {
        const { email, firstName, lastName, password, confirmPassword, agreeTOS } = this.state;
        return (
            <div>
                <div className="auth">
                    <div className="auth__row auth__center">
                        <div className="auth__text">
                            <h1 className="auth__text__header">Welcome to TBayShinny</h1>
                        </div>
                    </div>
                    <div className="auth__row auth__center">
                        <div className="auth__box">
                            <div className="auth-form">
                                <h3 className="auth-form__header">PLEASE REGISTER</h3>
                                <Form className="form" onSubmit={ (e) => this.submitForm(e) }>
                                    <Row form>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Input
                                                    type="text"
                                                    name="firstName"
                                                    id="firstNameInput"
                                                    placeholder="First Name"
                                                    value={ firstName.value }
                                                    valid={ firstName.validateCSS === 'has-success' }
                                                    invalid={ firstName.validateCSS === 'has-danger' }
                                                    onChange={
                                                        (e) => {
                                                            this.validateInput(e.target.value, e.target.name);
                                                            this.handleChange(e)
                                                        }
                                                    }
                                                />
                                                <FormFeedback>
                                                    {firstName.errors[0]}
                                                </FormFeedback>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Input
                                                    type="text"
                                                    name="lastName"
                                                    id="lastNameInput"
                                                    placeholder="Last Name"
                                                    value={ lastName.value }
                                                    valid={ lastName.validateCSS === 'has-success' }
                                                    invalid={ lastName.validateCSS === 'has-danger' }
                                                    onChange={
                                                        (e) => {
                                                            this.validateInput(e.target.value, e.target.name);
                                                            this.handleChange(e)
                                                        }
                                                    }
                                                />
                                                <FormFeedback>
                                                    {lastName.errors[0]}
                                                </FormFeedback>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row form>
                                        <Col>
                                            <FormGroup>
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    id="emailInput"
                                                    placeholder="Email"
                                                    value={ email.value }
                                                    valid={ email.validateCSS === 'has-success' }
                                                    invalid={ email.validateCSS === 'has-danger' }
                                                    onChange={
                                                        (e) => {
                                                            this.validateInput(e.target.value, e.target.name);
                                                            this.handleChange(e)
                                                        }
                                                    }
                                                />
                                                <FormFeedback>
                                                    {email.errors[0]}
                                                </FormFeedback>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row form>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Input
                                                    type="password"
                                                    name="password"
                                                    id="passwordInput"
                                                    placeholder="Password"
                                                    value={ password.value }
                                                    valid={ password.validateCSS === 'has-success' }
                                                    invalid={ password.validateCSS === 'has-danger' }
                                                    onChange={
                                                        (e) => {
                                                            this.validateInput(e.target.value, e.target.name);
                                                            this.handleChange(e)
                                                        }
                                                    }
                                                />
                                                <FormText>Must be at least 6 characters long.</FormText>
                                                <FormFeedback>
                                                    {this.state.password.errors[0]}
                                                </FormFeedback>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Input
                                                    type="password"
                                                    name="confirmPassword"
                                                    id="confirmPasswordInput"
                                                    placeholder="Confirm Password"
                                                    value={ confirmPassword.value }
                                                    valid={ confirmPassword.validateCSS === 'has-success' }
                                                    invalid={ confirmPassword.validateCSS === 'has-danger' }
                                                    onChange={
                                                        (e) => {
                                                            this.validateInput(e.target.value, e.target.name);
                                                            this.handleChange(e)
                                                        }
                                                    }
                                                />
                                                <FormFeedback>
                                                    {confirmPassword.errors[0]}
                                                </FormFeedback>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup check>
                                                    <Input
                                                        type="checkbox"
                                                        name="agreeTOS"
                                                        id="agreeTOS" 
                                                        value={ agreeTOS.value }
                                                        valid={ agreeTOS.validateCSS === 'has-success' }
                                                        invalid={ agreeTOS.validateCSS === 'has-danger' }
                                                        onChange={
                                                            (e) => {
                                                                // this.validateInput(e.target.value, e.target.name);
                                                                this.handleChange(e)
                                                            }
                                                        }
                                                    />{' '}
                                                    <Label for="agreeTOS" check>I have read and agree to the <a href={WaiverPDF} target='_blank'>waiver</a></Label>
                                                <FormFeedback>
                                                    {agreeTOS.errors[0]}
                                                </FormFeedback>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="login-form__actions mt3">
                                        <Button color="primary" type="submit" className="auth-form__submit">
                                            Register
                                        </Button>
                                        <span className="login-form__register">
                                            Or <Link to='/login' className="auth-form__register__link">login</Link> now
                                        </span>
                                    </div>
                                    <div className="mt2">
                                        { this.renderError() }
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        user: getFullUser(state)
    };
}

export default connect(mapStateToProps, authActions)(Register);


// WEBPACK FOOTER //
// ./src/components/Auth/Register/Register.js